import React from 'react';
import { Section, SectionHeading } from '../ui/Section';
import { Reveal } from '../ui/Reveal';
import { failures } from '../../data/content';
export function WhyMethodsFail() {
  return <Section className="bg-mist" aria-labelledby="fallan-titulo" data-id="element-372" data-mp="dksksywnx8bb">
      <div className="grid gap-10 lg:grid-cols-[2fr_3fr] lg:gap-16" data-id="element-373" data-mp="dmn4yb040wec">
        <Reveal data-id="element-374" data-mp="iibxhudppd15">
          <SectionHeading id="fallan-titulo" className="lg:sticky lg:top-16" data-id="element-375" data-mp="iiu0rayskrik">
            Por qué las dietas fallan <span className="text-gold" data-id="element-376" data-mp="3h33rll55k0jb">(y no es tu culpa)</span>
          </SectionHeading>
        </Reveal>

        <ul data-id="element-377" data-mp="3m2gc3z8jwviq">
          {failures.map((item, index) => <Reveal as="li" key={item.method} delay={index * 0.05} className="list-none" data-id="element-378" data-mp="3qz70d9uiexf8" data-mpi={index}>
              <div className="border-l-[3px] border-gold py-5 pl-6" data-id="element-379" data-mp="3v1jv737pxax8">
                <p className="text-base leading-relaxed text-body sm:text-lg" data-id="element-380" data-mp="3uypbxf0fxw5e">
                  <strong className="font-bold text-forest" data-id="element-381" data-mp="168y6pozgd3cq">{item.method}:</strong>{' '}
                  {item.explanation}
                </p>
              </div>
            </Reveal>)}
        </ul>
      </div>
    </Section>;
}